// extracted by mini-css-extract-plugin
export default {"quotes":"Quotes_quotes__syi+p","quote":"Quotes_quote__wNLae","quoteEnd":"Quotes_quoteEnd__2f+Vf","slideText":"Quotes_slideText__5QRsh","icon":"Quotes_icon__UJ5kD"};